export function setFormValue(state, { prop, value }) {
  state.form[prop] = value;
}

export function mapFormData(state, data) {
  state.form.id = data.id;
  state.form.title = data.name;
  state.form.description = data.description || "";
  state.form.logo = data.logo;
  state.form.banner = data.banner;
  state.form.product_sections = data.product_sections;
  state.form.is_company_owns = data.is_company_owns !== false;
  state.form.is_storeFront = data.is_storeFront || false;
}
export function clearFormData(state) {
  state.form = {
    id: null,
    chat: 0,
    title: "",
    description: "",
    logo: null,
    banner: null,
    product_sections: [],
    is_storeFront: false,
    is_company_owns: true,
  };
}

export function addProductSection(state, section) {
  state.form.product_sections.push(section);
}

export function setLoadedBrand(state, brand) {
  if (!brand?.id) {
    return;
  }

  state.loadedBrands[brand.id] = brand;
}
